import React from 'react';
import PropTypes from 'prop-types';

import equal from 'deep-equal';
import clone from 'clone-deep';

import { dig } from 'spiceutils';

import ListEditor from '../ListEditor';
import SelectedItemDisplayList from '../ListEditor/SelectedItemDisplayList';
import OpenListEditorButton from '../ListEditor/OpenListEditorButton';
import MultiselectContainer from './MultiselectContainer';
import AddItemButton from '../../AddItemButton';

import PresetList from './PresetList';

class CountryList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showListEditor: false,
      internalCountryList: props.cdf.CountryList || [],
    };
  }
  componentWillReceiveProps(newProps) {
    // If list editor not open and cdf has changed
    if (!this.state.showListEditor && !equal(this.props.cdf, newProps.cdf)) {
      this.setState({ internalCountryList: newProps.cdf.BreakList || [] });
    }
  }
  onAdd() {
    // if there isn't already an empty country group in the list
    if (this.state.internalCountryList.filter((v) => v.length === 0).length === 0) {
      const internalCountryList = this.state.internalCountryList ? clone(this.state.internalCountryList) : [];
      internalCountryList.push([]);
      this.setState({ internalCountryList });
    }
  }
  onRemove(index) {
    const internalCountryList = clone(this.state.internalCountryList);
    internalCountryList.splice(index, 1);
    this.setState({ internalCountryList });
  }
  onChange(index, val) {
    const internalCountryList = clone(this.state.internalCountryList);
    internalCountryList[index] = val;
    this.setState({ internalCountryList });
  }
  getTitle(countryListGroup) {
    // Take first 3 elements
    let title = countryListGroup.slice(0, 3).join(', ');
    // If originally had more than 3
    if (countryListGroup.length > 3) {
      title += '...';
    }
    return title.length > 0 ? title : 'Select at least one country';
  }
  toggleListEditor() {
    this.setState({
      // Reload our internal country list when exiting/entering modal
      internalCountryList: this.props.cdf.CountryList || [],
      showListEditor: !this.state.showListEditor,
    });
  }
  render() {
    if (dig(this.props.controlList, ['CountryList', 'Visible']) === true) {
      let listEditor = null;
      if (this.state.showListEditor) {
        listEditor = (
          <ListEditor modalTitle="Choose your countries." modalSubtitle="Use 'Add Group' button to add a country." toggleListEditor={() => this.toggleListEditor()} >
            <SelectedItemDisplayList
              arrayList={this.state.internalCountryList || []}
              cdf={this.props.cdf}
              updateCDF={this.props.updateCDF}
              controlList={this.props.controlList.CountryList}
              getTitle={this.getTitle}
              storedList={this.state.internalCountryList}
              template={MultiselectContainer}
              onChange={(i, v) => this.onChange(i, v)}
              onRemove={(i) => this.onRemove(i)}
              field="CountryList"
              mode="edit"
            />
            <AddItemButton onClick={() => this.onAdd()}></AddItemButton>
          </ListEditor>
        );
      }
      return (
        <div>
          <label htmlFor="countryList">Currently selected countries:</label>
          <SelectedItemDisplayList
            arrayList={this.props.cdf.CountryList || []}
            updateCDF={this.props.updateCDF}
            getTitle={this.getTitle}
            onRemove={(i) => this.onRemove(i)}
            field="CountryList"
            mode="display"
            name="countryList"
          />
          <OpenListEditorButton toggleListEditor={() => this.toggleListEditor()} />
          <PresetList updateCDF={this.props.updateCDF} />
          {listEditor}
        </div>
      );
    }
    return null;
  }
}

CountryList.propTypes = {
  cdf: PropTypes.object.isRequired,
  updateCDF: PropTypes.func,
  controlList: PropTypes.object,
};

export default CountryList;



// WEBPACK FOOTER //
// ./app/components/FormControls/CountryList/index.js